<div
  class="alert"
  [ngClass]="alertModel.type">
  {{alertModel.message}}
</div>
